import MapSettings from '../map.settings';

export const MAP_STYLES: google.maps.MapTypeStyle[] = [
  { elementType: 'geometry', stylers: [{ color: '#f5f5f5' }] },
  { elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { elementType: 'labels.text.fill', stylers: [{ color: '#616161' }] },
  { elementType: 'labels.text.stroke', stylers: [{ color: '#f5f5f5' }] },
  {
    featureType: 'administrative.country',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#b1c6d3' }, { weight: 1 }],
  },
  {
    featureType: 'administrative.land_parcel',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#bdbdbd' }],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{ color: '#eeeeee' }],
  },
  { featureType: 'poi', elementType: 'geometry.stroke', stylers: [{ color: '#fafafa' }] },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#757575' }],
  },
  { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#e5e5e5' }] },
  {
    featureType: 'poi.park',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#9e9e9e' }],
  },
  { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#ffffff' }] },
  {
    featureType: 'road',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#fafafa' }],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#fafafa' }],
  },
  {
    featureType: 'road.arterial',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#757575' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry',
    stylers: [{ color: '#dadada' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#fafafa' }],
  },
  {
    featureType: 'road.highway',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#616161' }],
  },
  {
    featureType: 'road.highway.controlled_access',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#fafafa' }],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#fafafa' }],
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#9e9e9e' }],
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [{ color: '#e5e5e5' }],
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#fafafa' }],
  },
  {
    featureType: 'transit.station',
    elementType: 'geometry',
    stylers: [{ color: '#eeeeee' }],
  },
  {
    featureType: 'transit.station',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#fafafa' }],
  },
  {
    featureType: 'transit.station.airport',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#fafafa' }],
  },
  {
    featureType: 'transit.station.bus',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#fafafa' }],
  },
  {
    featureType: 'transit.station.rail',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#fafafa' }],
  },
  { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#c9c9c9' }] },
  { featureType: 'water', elementType: 'geometry.fill', stylers: [{ color: '#51a3d6' }] },
  {
    featureType: 'water',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#9e9e9e' }],
  },
];

export const DEFAULT_MARKER_OPTIONS: google.maps.MarkerOptions = { draggable: false };
export const DEFAULT_CIRCLE_OPTIONS: google.maps.CircleOptions = {
  strokeColor: '#3c59ff',
  fillColor: '#3c59ff',
  strokeWeight: 1,
};

export const DEFAULT_MAP_OPTIONS: google.maps.MapOptions = {
  styles: MAP_STYLES,
  minZoom: MapSettings.MAP_MIN_ZOOM_LEVEL,
  maxZoom: MapSettings.MAP_MAX_ZOOM_LEVEL,
  disableDefaultUI: true,
  zoomControl: true,
  draggableCursor: null,
  gestureHandling: 'cooperative',
  // scrollwheel: false,
  fullscreenControl: false,
  streetViewControl: false,
  mapTypeControl: false,
  restriction: {
    strictBounds: true,
    latLngBounds: {
      east: 180,
      north: 85.0728994691392,
      south: -85.0728994691392,
      west: -180,
    },
  },
};
